const NotificationsConfig = {
  profiles: {
    failed: {
      message: 'profiles.failed.message',
      solution: 'profiles.failed.solution'
    },
    success: {
      message: 'profiles.success.message'
    }
  },
  search: {
    failed: {
      message: 'search.failed.message',
      solution: 'search.failed.solution'
    }
  },
  econsultApplyForPermission: {
    failed: {
      message: 'econsultApplyForPermission.failed.message'
    },
    success: {
      message: 'econsultApplyForPermission.success.message'
    }
  },
  econsultRequestClarification: {
    failed: {
      message: 'Case.consult.requestClarification'
    },
    success: {
      message: 'Case.consult.requestClarification'
    }
  },
  econsultProvideConsult: {
    failed: {
      message: 'Case.consult.provideConsult'
    },
    success: {
      message: 'Case.consult.provideConsult'
    }
  },
  econsultGeneral: {
    failed: {
      message: 'EconsultGeneral.failed.message'
    },
    success: {
      message: 'EconsultGeneral.success.message'
    }
  },
  econsultNotedAdd: {
    failed: {
      message: 'EconsultNoteAdd.failed.message'
    },
    success: {
      message: 'EconsultNoteAdd.success.message'
    }
  },
  econsultCompleteConsult: {
    failed: {
      message: 'Case.consult.complete'
    },
    success: {
      message: 'Case.consult.caseCompleted'
    }
  },
  econsultCancelConsult: {
    failed: {
      message: 'Case.consult.cancel.failed'
    },
    success: {
      message: 'Case.consult.cancel.success'
    }
  },
  econsultDraftConsult: {
    failed: {
      message: 'Case.consult.draftSendFailed'
    },
    success: {
      message: 'Case.consult.draftSent'
    }
  },
  econsultDeleteDraft: {
    failed: {
      message: 'Case.consult.draftDeleteFailed'
    },
    success: {
      message: 'Case.consult.draftDeleted'
    }
  },
  econsultSaveDraft: {
    failed: {
      message: 'Case.consult.draftSaveFailed'
    },
    success: {
      message: 'Case.consult.draftSaved'
    }
  },
  econsultDraftInvalid: {
    failed: {
      message: 'Case.consult.draftInvalid'
    },
    success: {
      message: 'Case.consult.draftInvalid'
    }
  }
};

export default NotificationsConfig;
